<template>
  <v-main fill-height style="background: #eee; height: 100vh" fluid>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <h1 class="text-h5">The system is currently being upgraded.</h1>
          <p>Please be patient while we work on improving your experience. You can check back later for updates.</p>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'UpgradeModeView'
};
</script>
